import React, { createContext, useContext } from 'react';
import useToast from '../hooks/useToast';

interface ToastContextType {
  addToast: (message: string, type: 'success' | 'error') => void;
  toasts: Array<{
    id: string;
    message: string;
    type: 'success' | 'error';
  }>;
  removeToast: (id: string) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const toast = useToast();

  return (
    <ToastContext.Provider value={toast}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToastContext must be used within a ToastProvider');
  }
  return context;
};